import React from "react"
import PropTypes from "prop-types"
import Select from "@irati/ui/src/FormItem/Select"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import withRewardOnChange from "./withRewardOnChange"

const PROPERTY = "status"

export const schema = Validation.string("A status must be selected")

const Status = ({reward, onChange, label, required, referenceData, ...props}) => {
  return (
    <Select
      name={PROPERTY}
      isClearable={false}
      value={reward[PROPERTY]}
      options={referenceData.status.map((s) => {
        return {value: s.value, label: s.description}
      })}
      onChange={(status) => onChange(reward, PROPERTY, status)}
      label={`${label}${required ? "*" : ""}`}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

Status.propTypes = {
  required: PropTypes.bool,
  reward: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  referenceData: PropTypes.object.isRequired,
  label: PropTypes.string,
  validation: PropTypes.object
}

Status.defaultProps = {
  required: true,
  label: "Status:",
  validation: schema,
  id: "rewardStatus"
}

export default withRewardOnChange(Status)
